import { useNavigate } from '@tanstack/react-router'
import { Button } from 'antd'
import { useIsFirstTimeLogin } from '../hooks/use-is-first-time-login'
import { ArrowLeft } from './ArrowLeft'

/**
 * "Back" action for the authenticator-app step, whose destination depends on
 * how the user reached it:
 * - first-time setup → back to "/login/setup-authenticator"
 * - returning sign-in → back to "/login"
 *
 * Defaults to the first-time target while {@link useIsFirstTimeLogin} resolves
 * (this page is framed as "Step 3 of 4" first-time setup), then corrects for
 * returning users — keeping the link present without layout shift.
 */
export function VerifyAppBackLink() {
  const isFirstTime = useIsFirstTimeLogin() ?? true
  const navigate = useNavigate()

  return (
    <Button
      type="link"
      id="btn-otp-app-cancel"
      icon={<ArrowLeft />}
      className="text-xs font-semibold"
      onClick={() => navigate({ to: isFirstTime ? '/login/setup-authenticator' : '/login' })}
    >
      {isFirstTime ? 'Back to set up authenticator' : 'Back to sign in'}
    </Button>
  )
}
